
import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import CreatableSelect from "react-select/creatable";
import CompaniesSelectInput from "./ConpaniesSelectInput";
import { storeLead } from "../actions/StoreLeadAction";
import toast from "react-hot-toast";
// import { toast } from "react-toastify";

const RemoveOtherContactModal = ({
  showModal,
  setShowModal,
  contactDetails,
  companyName,
  onSave,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [newCompanyName, setNewCompanyName] = useState(companyName);

  const closeModal = () => {
    setNewCompanyName("");
    setShowModal(false);
  };

  const handleSave = async () => {
    setIsLoading(true);
    console.log("Saving with new company name:", contactDetails);
    // Implement save logic here

    const saveData = {
      ...contactDetails,
      company_name: newCompanyName,
      lead_source: "manual",
    };

    const resp = await storeLead(saveData);
    if (resp.success) {
      toast.success("Lead Updated successfully!");

      if (onSave) {
        onSave(saveData);
      }
      setNewCompanyName("");
      setIsLoading(false);
      closeModal();
    } else {
      toast.error(
        "An error occurred while processing your request. Please try again!"
      );
    }
  };

  const footer = () => {
    return (
      <React.Fragment>
        <button
          type="button"
          className="cancel-btn"
          onClick={closeModal}
          disabled={isLoading}
        >
          Cancel
        </button>
        <button
          type="button"
          className="save-btn btn-primary"
          onClick={handleSave}
          disabled={isLoading}
        >
          {isLoading ? "Saving..." : "Save"}
        </button>
      </React.Fragment>
    );
  };

  return (
    <div id="edit" className="crm">
      <Modal
        isOpen={showModal}
        onClose={closeModal}
        title={`Remove Contact: '${
          (contactDetails && contactDetails.name) || ""
        }'`}
        footer={footer()}
      >
        <div id="edit" className="input-box crm">
          <label className="input-label" htmlFor="name">
            Company Name <span>*</span>
          </label>
          <CompaniesSelectInput
            value={
              newCompanyName
                ? { label: newCompanyName, value: newCompanyName }
                : null
            }
            onChange={(value) => {
              setNewCompanyName(value ? value : "");
            }}
            disabled={isLoading}
          />
        </div>
      </Modal>
    </div>
  );
};

export default RemoveOtherContactModal;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/common/RemoveOtherContactModal.js